<template>
  <div class="compressed-content">
    <div class="page-question">
      <h3>
        Have any of the following relatives been diagnosed with familial hypercholesterolemia?
        <span class="information-popover" v-b-popover.hover.auto="hypercholesterolemiaInformation">i</span><br />
        <i>(check all that apply)</i>
      </h3>
    </div>

    <div class="mb-4">
      <b>Note:</b> FH is a diagnosed genetic condition and not simply high <br />
      cholesterol. See pop-out for more information about FH.
    </div>

    <v-form-group class="card-selector page-buttons" :validator="$v.familyDiagnoses">
      <b-form-checkbox v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isNoneDiagnosed"
                       @change="onNoneSelected">
        None
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isUnknown"
                       @change="onUnknownSelected">
        I Don’t Know
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isMotherDiagnosed"
                       @change="onMotherSelected">
        Mother
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isFatherDiagnosed"
                       @change="onFatherSelected">
        Father
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isSiblingDiagnosed"
                       @change="onSiblingSelected">
        Sibling
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isChildrenDiagnosed"
                       @change="onChildrenSelected">
        Children
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isMaternalGrandparentDiagnosed"
                       @change="onMaternalGrandparentSelected">
        Mother’s Parents
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isPaternalGrandparentDiagnosed"
                       @change="onPaternalGrandparentSelected">
        Father’s Parents
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';
  import { hypercholesterolemiaInformation } from '@/constants';

  export default {
    mixins: [formMixin],

    data() {
      return {
        hypercholesterolemiaInformation,
      }
    },

    validations: {
      familyDiagnoses: {
        anyOptionRequired: anyOptionRequired((value) => value.isNoneDiagnosed || value.isUnknown
          || value.isMotherDiagnosed || value.isFatherDiagnosed || value.isSiblingDiagnosed
          || value.isChildrenDiagnosed || value.isMaternalGrandparentDiagnosed
          || value.isPaternalGrandparentDiagnosed)
      }
    },

    computed: {
      ...mapState(["survey"]),

      familyDiagnoses() { return this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses; }
    },

    methods: {
      onNoneSelected(value) {
        this.setOptions(value, false, false, false, false, false, false, false);
      },

      onUnknownSelected(value) {
        this.setOptions(false, value, false, false, false, false, false, false);
      },

      onMotherSelected(value) {
        this.setOptions(false, false, value, this.familyDiagnoses.isFatherDiagnosed,
          this.familyDiagnoses.isSiblingDiagnosed, this.familyDiagnoses.isChildrenDiagnosed,
          this.familyDiagnoses.isMaternalGrandparentDiagnosed, this.familyDiagnoses.isPaternalGrandparentDiagnosed);
      },

      onFatherSelected(value) {
        this.setOptions(false, false, this.familyDiagnoses.isMotherDiagnosed, value,
          this.familyDiagnoses.isSiblingDiagnosed, this.familyDiagnoses.isChildrenDiagnosed,
          this.familyDiagnoses.isMaternalGrandparentDiagnosed, this.familyDiagnoses.isPaternalGrandparentDiagnosed);
      },

      onSiblingSelected(value) {
        this.setOptions(false, false, this.familyDiagnoses.isMotherDiagnosed, this.familyDiagnoses.isFatherDiagnosed,
          value, this.familyDiagnoses.isChildrenDiagnosed, this.familyDiagnoses.isMaternalGrandparentDiagnosed,
          this.familyDiagnoses.isPaternalGrandparentDiagnosed);
      },

      onChildrenSelected(value) {
        this.setOptions(false, false, this.familyDiagnoses.isMotherDiagnosed, this.familyDiagnoses.isFatherDiagnosed,
          this.familyDiagnoses.isSiblingDiagnosed, value, this.familyDiagnoses.isMaternalGrandparentDiagnosed,
          this.familyDiagnoses.isPaternalGrandparentDiagnosed);
      },

      onMaternalGrandparentSelected(value) {
        this.setOptions(false, false, this.familyDiagnoses.isMotherDiagnosed, this.familyDiagnoses.isFatherDiagnosed,
          this.familyDiagnoses.isSiblingDiagnosed, this.familyDiagnoses.isChildrenDiagnosed,
          value, this.familyDiagnoses.isPaternalGrandparentDiagnosed);
      },

      onPaternalGrandparentSelected(value) {
        this.setOptions(false, false, this.familyDiagnoses.isMotherDiagnosed, this.familyDiagnoses.isFatherDiagnosed,
          this.familyDiagnoses.isSiblingDiagnosed, this.familyDiagnoses.isChildrenDiagnosed,
          this.familyDiagnoses.isMaternalGrandparentDiagnosed, value);
      },

      setOptions(isNoneDiagnosed, isUnknown, isMotherDiagnosed, isFatherDiagnosed, isSiblingDiagnosed,
        isChildrenDiagnosed, isMaternalGrandparentDiagnosed, isPaternalGrandparentDiagnosed) {
        this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isNoneDiagnosed = isNoneDiagnosed;
        this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isUnknown = isUnknown;
        this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isMotherDiagnosed = isMotherDiagnosed;
        this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isFatherDiagnosed = isFatherDiagnosed;
        this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isSiblingDiagnosed = isSiblingDiagnosed;
        this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isChildrenDiagnosed = isChildrenDiagnosed;
        this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isMaternalGrandparentDiagnosed = isMaternalGrandparentDiagnosed;
        this.survey.bloodBiochemistry.hypercholesterolemia.familyDiagnoses.isPaternalGrandparentDiagnosed = isPaternalGrandparentDiagnosed;
      }
    }
  };
</script>